import {
    deleteItemFromCollection,
} from "directus/src/operations";

export async function removeOutcomes(id) {
    try {
        const response = await deleteItemFromCollection("outcomes", id);
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
}